<template>
      <div class="h-dialogContainer">
        <div class="row h-row-inputBox">
          <div class="form-group h-col-inputBox">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('NSMF.sliceProfile')}}:</div>
                  <ejs-grid :dataSource="sliceProfileData" ref="sliceProfileGrid" height="280">
                  <e-columns>
                  <e-column field='name' minWidth='10' :headerText='$t("NSMF.name")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
                  <e-column field='sST' minWidth='10' :headerText='$t("NSMF.sst")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='sstFormat'></e-column>
                  <e-column field='sd' minWidth='10' :headerText='$t("NSMF.sd")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'  :formatter='sdFormat'></e-column>
                  <e-column field='mcc' minWidth='10' :headerText='$t("NSMF.mcc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mccFormat'></e-column>
                  <e-column field='mnc' minWidth='10' :headerText='$t("NSMF.mnc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mncFormat'></e-column>
                  <e-column field='neConfig' minWidth='10' :headerText='$t("NSMF.neDeploy")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='neDeployFormat'></e-column>
                  </e-columns>
                  </ejs-grid>
                  <ejs-pager
                  ref="pager"  @click="getSliceProfileList()" :pageSize="page.pageSize" :currentPage="page.pageNo" :totalRecordsCount="page.totalCount" :pageCount="page.pageCount">
                  </ejs-pager>
            </div>
          </div>
        </div>
        <div class="row h-row-inputBox">
          <div class="form-group h-col-inputBox">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('NSMF.runMode')}}:</div>
              <ejs-radiobutton
                class="h-inputLit"
                name="runMode"
                :label="$t('NSMF.oamOne')"
                :checked="choiceRunMode"
                value="1"
                :change="runModeChange"
              ></ejs-radiobutton>
              <!-- <ejs-radiobutton
                class="h-inputLit"
                name="runMode"
                :label="$t('NSMF.oamMore')"
                :checked="!choiceRunMode"
                value="2"
                :change="runModeChange"
              ></ejs-radiobutton> -->
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "InstanceSliceProfile",
  data() {
    return {
      choiceRunMode: true,
      runModeRadioValue:"1",
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },
      selectedGroupIds: [],
      sliceProfileData: [],
      selectIndexes: []
    };
  },
  mounted() {},
  methods: {
    runModeChange(args) {
        this.runModeRadioValue = args.value;
      },
    sstFormat(grids, data) {
      if (null !== data && undefined !== data && null !== data.sNSSAIList) {
        let sstSource = data.sNSSAIList.split(":")[0];
        if (sstSource === "1") {
          return "eMBB";
        } else if (sstSource === "2") {
          return "URLLC";
        } else if (sstSource === "3") {
          return "MIoT";
        } else if (sstSource === "4") {
          return "V2X";
        }
      } else {
        return "";
      }
    },

    mccFormat(grids, data) {
      return data.pLMNList.split(":")[0];
    },
    mncFormat(grids, data) {
      return data.pLMNList.split(":")[1];
    },
    sdFormat(grids, data) {
      return data.sNSSAIList.split(":")[1];
    },
    neDeployFormat(grids, data) {
      let neDeployStr = "";
      const neList = JSON.parse(data.neConfig);
      neList.forEach(itemNe => {
        neDeployStr += itemNe.neType + ";";
      });
      return neDeployStr;
    },
    init(selectedGroupIds) {      
      this.selectedGroupIds = selectedGroupIds;
    },
    getSliceProfileList(id) {
      const url = "/lte/ems/networkSlice/listSliceProfile/byServiceProfileId";
      const params = {
        serviceProfileId: id,
        pageNo: parseInt(this.page.pageNo, 10),
        pageSize: parseInt(this.page.pageSize, 10)
      };
      const That = this;
      That.$axios
        .get(
          `/lte/ems/networkSlice/listSliceProfile/byServiceProfileId?pageNo=${params.pageNo}&pageSize=${params.pageSize}&serviceProfileId=${params.serviceProfileId}`
        )
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            const result = response.data.resultVal;
            That.page.totalCount = result.totalCount;
            That.sliceProfileData = result.result;
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString
            });
          }
        });
    },

    getSelectSliceProfile() {
      return this.$refs.sliceProfileGrid.getSelectedRecords();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.sliceProfileGrid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.no_checked")}`
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.too_many_checked")}!`
        });
        return false;
      }
      EventBus.$emit("runModeRadioValue",this.runModeRadioValue)
      return selectedRecords;
    }
  }
};
</script>
